import { useEffect, useState, useRef } from "react";

const useInterval = (timerCount = 60, ms = 1000) => {
  const timerInterval = useRef<ReturnType<typeof setInterval>>();
  const [timer, setTimer] = useState(timerCount);

  useEffect(() => {
    if (timer === 60) {
      timerInterval.current = setInterval(() => {
        setTimer((oldTimer) => {
          if (oldTimer === 0) {
            clearInterval(timerInterval.current!);
            return oldTimer;
          }
          return oldTimer - 1;
        });
      }, ms);
    }
  }, [timer, ms]);

  useEffect(() => {
    return () => {
      clearInterval(timerInterval.current!);
    };
  }, []);

  return [timer, setTimer] as const;
};

export default useInterval;
